<template>
  <filtertron-tray-section
    id="chapter-configurator-managers"
    :title="lang.get('chapters.configuration.managers.label')"
  >
    <div class="fields island">
      <div class="form-group">
        <multiselect
          id="manager-ids"
          name="managerIds[]"
          :counter="false"
          :options="chapterManagers"
          :selected-options="chapter.managerIds"
          :select-all-label="lang.get('multiselect.select_all')"
          :placeholder="lang.get('chapters.form.managers.placeholder')"
          @selected="onSelected"
        />
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import _ from 'underscore';
import { mapState } from 'vuex';
import { Multiselect } from 'vue-bootstrap';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection,
    Multiselect
  },
  mixins: [handleInputMixin],
  props: {
    chapter: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('entryForm', ['chapterManagers'])
  },
  methods: {
    onSelected(managerIds) {
      if (
        !_.isEqual([...this.chapter.managerIds].sort(), [...managerIds].sort())
      ) {
        this.handleInput('managerIds', managerIds);
      }
    }
  }
};
</script>
